import React from 'react';
import '../App.css';
import Hero from '../components/hero/Hero';
import Section from '../components/section/Section';

function Home() {
  return (
    <>
      <Hero />
      <Section />
    </>
  );
}

export default Home;
